import { useEffect, useRef, useState } from 'react'
import { Subject } from 'rxjs/Subject'

export function useDebounce<T>(delay: number, initialValue: T, callback: (param: T) => void): [T, (args: T) => void] {
  const [value, setValue] = useState<T>(initialValue)
  const subject$ = useRef<Subject<T>>(undefined)

  useEffect(() => {
    subject$.current = new Subject()
    subject$.current.debounceTime(delay).subscribe(callback)

    return () => {
      if (subject$.current) {
        subject$.current.unsubscribe()
      }
    }
  }, [])

  useEffect(() => {
    if (value !== null && subject$.current) {
      subject$.current.next(value)
    }
  }, [value])

  return [value, setValue]
}
